__webpack_require__.p = "https://qa-static-common.zhihuiya.com/backoffice-widget/1.0.0/";